export const translationNavigation_en_part2 = {
  pageSiteTitleHeading: "Page-specific site titles",
  pageSiteTitleHelp: "Page-specific site titles help",
  pageSiteTitleDescription:
    "Change the title in the widget's top bar on selected pages. Other pages use the default Site title above.",
  pageSiteTitleText: "Site title for these pages",
  pageSiteTitleNoDefault: "No default site title set",
  pageTitleHeading: "Page-specific header titles",
  pageTitleHelp: "Page-specific header titles help",
  pageTitleImmediate: "Saves immediately",
  pageTitleSharedRule:
    "This rule also controls another title or launcher images. Changing its URL or priority affects them; Remove title keeps them.",
  pageTitleDescription:
    "Change the heading inside the chat on selected pages. Other pages use the default Header title above.",
  pageTitleMatching:
    "A path such as /delivery matches any URL containing that text (case-sensitive). For wildcards, enter the full URL, for example https://example.com/products/*.",
  pageTitleSaveHelp: "Add title and Save title apply immediately. These rules do not need Publish.",
  pageTitleEmpty: "No page-specific titles yet. Your default title applies everywhere.",
  pageTitleAddHeading: "Add a page-specific title",
  pageTitleUrl: "Page URL or pattern",
  pageTitleText: "Header title for these pages",
  pageTitleExample: "Delivery help",
  pageTitlePriority: "Matching priority",
  pageTitlePriorityHelp:
    "The first matching page rule wins. Lower numbers are checked first; equal numbers use the oldest rule. URL and priority apply to all titles and images using this rule.",
  pageTitleOrder: "Priority (lower first)",
  pageTitleSave: "Save title",
  pageTitleAdd: "Add title",
  pageTitleRemove: "Remove title",
  pageTitleSaved: "Saved",
  pageTitleSaving: "Saving…",
  pageTitleTest: "Check a page URL",
  pageTitleTestHelp:
    "Enter a full page URL to see which saved title applies. Save your edits before checking.",
  pageTitleMatched: "This page uses a custom title:",
  pageTitleDefault: "This page uses the default title:",
  pageTitleNoDefault: "No default header title set",
  pageTitleMatchingRule: "Matching page rule",
  showLivechatAvailability: "Show livechat availability in the chat title",
  showLivechatAvailabilityDescription:
    "Show a green dot when livechat is available, using this chatbot's livechat availability and opening hours. Nothing is shown when livechat is offline.",
  widgetLeftSide: "Show widget on the left",
  widgetLeftSideDescription:
    "Place the launcher and chat window on the left, with popup messages extending to the right. Applies to desktop and mobile launchers.",
  launcherEdgeDistance: "Launcher distance from edge",
  mobileLauncherEdgeDistance: "Mobile launcher distance from edge",
  mobileLauncherLeftEdge: "Compact launcher on left edge",
  mobileLauncherLeftEdgeDescription:
    "Show a 44 px square launcher halfway up the left edge on mobile, using your existing icon. Overrides the mobile position and size while enabled.",
  userMessageColor: "User message",
  userMessageTextColor: "User message text",
  userMessageBorderColor: "User message border",
  inputTextColor: "Input text",
  inputPlaceholderColor: "Input placeholder",
  inputBackgroundColor: "Input background",
  inputBorderColor: "Input border",
  inputFieldHeight: "Input field height (px)",
  inputFieldHeightDescription: "The input field height.",
  sendButtonIconColor: "Send button icon",
  headerLogo: "Header Logo (upload file)",
  messageIcon: "Avatar (upload file)",
  messageIconSize: "Avatar size (px)",
  messageIconSizeDescription: "The avatar size.",
  fontSize: "Text size (px)",
  fontSizeDescription: "Chat message text size. Default is 16. Allowed range: 10–24.",
  headerTitle: "Header Title",
  headerSubtitle: "Header Subtitle",
  formattedTextHint: "Use Bold or Link to format parts of the text.",
  formattedTextBold: "Bold",
  formattedTextLink: "Link",
  formattedTextLinkPrompt: "Enter link URL",
  privacyPolicyUrl: "Privacy Policy URL",
  headerAlignment: "Header Alignment",
  alignLeft: "Align Left",
  alignCenter: "Center",
  alignRight: "Align Right",
  siteTitle: "Site Title",
  initialMessage: "Initial Message",
  buttonColor: "Button background",
  discountPriceColor: "Discount price",
  surfaceThemeGroup: "Surface",
  headerThemeGroup: "Header",
  messagesThemeGroup: "Messages",
  inputThemeGroup: "Input",
  productCardThemeGroup: "Product card",
  addToCartButtonIcon: "Add-to-Cart Button Icon",
  addToCartButtonIconDescription:
    "Upload a custom icon for the add-to-cart button on product cards. Leave empty to use the default shopping cart icon.",
  addToCartDisabledHint: "Enable add-to-cart in admin settings to customize the icon.",
  moreColorSettings: "More Color Settings",
  popupMessage: "Popup Message",
  publish: "Publish",
  uploadLogo: "Upload Logo",
  uploadIcon: "Upload Icon",
  selectChatbot: "Select Chatbot",
  editingChatbotId: "Editing Chatbot ID",
  textTooLongWarning: "Text may appear poorly on smaller screens",
  borderRadius: "Border Radius",
  borderRadiusDescription:
    "Controls roundness of chatbot corners (0.5 = sharp, 1.0 = normal, 2.0 = very round)",
  zIndexButton: "Z-Index - Button (Layering)",
  zIndexChatWindow: "Z-Index - Chat Window (Layering)",
  customChatButtonImage: "Custom Chat Button Image (Optional)",
  customChatButtonDescription:
    "Upload a custom image or GIF to replace the default SVG chat button. Leave empty to use the default button. The whole image can be clicked, so crop away transparent edges.",
  mobileCustomizations: "Mobile Customizations",
  mobileCustomizationsDescription:
    "Optional overrides for mobile devices. If not set, desktop settings are used.",
  mobileChatButtonImage: "Mobile Chat Button Image",
  mobileChatButtonDescription:
    "Upload a separate image for mobile view. Leave empty to use the desktop button. The whole image can be clicked, so crop away transparent edges.",
  adaptiveIconColor: "Adaptive start button color",
  adaptiveIconColorHint:
    "Applies only to the chat/start button. Upload a simple icon for best contrast on light and dark backgrounds.",
  mobileButtonPositionBottom: "Mobile Button Position - Bottom",
  mobileButtonPositionRight: "Mobile Button Position - Right",
  buttonSize: "Button Size (px)",
  buttonSizeDescription:
    "The size of the chat button in pixels, from 30 to 200. A custom image keeps its proportions, and this is its longer side. Default: 74",
  chatbotWidth: "Chatbot Width",
  chatbotHeight: "Chatbot Height",
  chatbotSizeDescription: "Desktop size.",
  openAnimationEnabled: "Open chatbot with slide animation",
  mobileButtonSize: "Mobile Button Size (px)",
  mobileButtonSizeDescription:
    "The size of the chat button on mobile in pixels, from 30 to 200. A custom image keeps its proportions, and this is its longer side. Default: 50",
  launcherSizeClampedNotice: "The chat button is shown at {size} px.",
  removeButton: "Remove",
  resetToDefault: "Reset to default",
  clickSaveToPersist: "Click Save to persist",
  saveReminder: "Changes are only saved to database when you click the Save button above",
  showPopupOnMobile: "Show popup on mobile devices",
  showPopupOnMobileDescription: "Uncheck to disable popup on mobile (will still show on desktop)",
  livePreview: "Live Preview",
  openPreviewInNewTab: "Open in new tab",
  fullscreen: "Fullscreen",
  exitFullscreen: "Exit Fullscreen",
  desktop: "Desktop",
  mobile: "Mobile",
  chatbotActive: "Active",
  chatbotDisabled: "Disabled",
  disabledSince: "Disabled since",
  disableChatbot: "Disable Chatbot",
  disableChatbotConfirmation:
    "Are you sure you want to disable this chatbot? It will no longer be visible on your website.",
  enableChatbot: "Enable chatbot",
  enableChatbotConfirmation:
    "Are you sure you want to enable this chatbot? It will be visible again on your website for visitors.",
  cancel: "Cancel",
  disable: "Disable",
  enable: "Enable",
  developerChatbotVisibilityTitle: "Chatbot on your website",
  developerChatbotVisibilitySectionDescription:
    "Turn the public chatbot on or off for visitors. This does not affect editing or preview on the Chatbot page.",
  developerChatbotVisibilityChatbotLabel: "Chatbot",
  developerDisableChatbotButton: "Disable chatbot on website",
  developerEnableChatbotButton: "Enable chatbot on website",
  developerChatbotVisibilityAcknowledge: "I understand this changes the live website for visitors.",
  developerChatbotVisibilityNoChatbots:
    "No chatbots are linked to this account. Chatbot IDs are loaded when you sign in.",
  developerChatbotVisibilityDisabledNotice: "The chatbot is disabled on the public website.",
  developerChatbotVisibilityEnabledNotice: "The chatbot is now enabled on the public website.",
  developerChatbotVisibilityStatusActive: "Active on website",
  developerChatbotVisibilityStatusDisabled: "Disabled on website",
  developerChatbotVisibilityLoadError: "Failed to load chatbot status.",
  developerChatbotVisibilityToggleError: "Failed to update chatbot status.",
  popupDailyDesktop: "Desktop: maximum displays per day",
  popupTotalDesktop: "Desktop: maximum displays in total",
  popupDailyMobile: "Mobile: maximum displays per day",
  popupTotalMobile: "Mobile: maximum displays in total",
  popupEveryNthPage: "Show on every Nth matching page",
  popupDismissDays: "Pause after closing (days)",
  popupFrequency: "Display frequency",
  popupUseDefault: "Use bot default",
  popupResetDefaults: "Reset to bot defaults",
  popupFrequencyHelp:
    "Limits apply separately to each bubble in this browser. Daily limits reset at midnight Copenhagen time. Matching pages carry across days. Closing a bubble pauses only that bubble; opening chat pauses all bubbles for today. Set a display cap to 0 to disable that layout.",
  popupMaxDisplays: "Popup Max Displays (Desktop and Mobile)",
  popupMaxDisplaysDescription:
    "Maximum appearances per popup in the visitor's browser, on desktop and mobile. Set to 0 to disable popups. Default: 2",
  chatbotWindowDimensions: "Chatbot Window Dimensions",
  chatbotWindowDimensionsDescription:
    "Control how the chatbot iframe is sized. Supports CSS values like px, vw, vh, calc(), etc.",
  desktopWidth: "Desktop Width",
  desktopHeight: "Desktop Height",
  mobileWidth: "Mobile Width",
  mobileHeight: "Mobile Height",
  enlargedWidth: "Enlarged Width",
  enlargedHeight: "Enlarged Height",
  // Livechat Settings translations
  // Livechat Settings translations
  livechatSettingsTitle: "Livechat Settings",
  agentInformation: "Agent Information",
  agentNameLabel: "Your Agent Name",
  profilePicture: "Profile Picture",
};
